import { Component, ElementRef, Input, Renderer2 } from '@angular/core'
import { FormBuilder } from '@angular/forms'
import { FieldsEditorActionManagerService } from '../../fields-editor/fields-editor-action-manager.service'
import { FieldPlaceholderComponent } from '../field-placeholder.component'
import { SignFieldType } from '@tokeet-frontend/signature'

@Component({
  selector: 'app-signature-placeholder',
  templateUrl: './signature-placeholder.component.html',
  styleUrls: ['./signature-placeholder.component.scss', '../global-fields.scss'],
})
export class SignaturePlaceholderComponent extends FieldPlaceholderComponent {
  type = SignFieldType.Signature

  @Input() required = true
  @Input() label: string

  disableCustomFont = true

  defaultLabel = $localize`Signature`

  constructor(
    render: Renderer2,
    fb: FormBuilder,
    elementRef: ElementRef,
    actionManager: FieldsEditorActionManagerService
  ) {
    super(render, fb, elementRef, actionManager)
  }
}
